import { Card, Select, Space, Table, theme } from 'antd'
import React from 'react'
import { hexToRGBA } from '../../../lib/utils'
import { CarePlanTemplatesNewRecordDataColumnTemplate } from '../../Chronic Care Plans/utils/templates'

const DataTrackerForm = ({
  handleAddTracking,
  handleUpdateTracker,
  dataPoints,
  data,
  handleRemoveTracker,
  planType,
  planLabel,
  trackerType
}) => {
  const filterChosenDataPoints = (item) => {
    let index = -1
    index = data.findIndex((i) => i.dataKey === item.key)
    return index === -1
  }

  // Display the correct plan type in UI
  const displayLabel =
    planLabel || (planType ? planType.charAt(0).toUpperCase() + planType.slice(1) + ' Plan' : 'Care Plan')

  // Determine what type of tracking is being handled
  const trackingType = trackerType || 'health'
  const trackingTitle = trackingType.charAt(0).toUpperCase() + trackingType.slice(1)

  const { token } = theme.useToken()
  return (
    <Card>
      <h1 style={{ color: token.colorPrimary }}>{trackingTitle.toUpperCase()} TRACKERS</h1>
      <p>
        Please select any {trackingType} readings you want to track for this {displayLabel.toLowerCase()}.
      </p>
      <Card
        size='small'
        style={{ marginTop: 12 }}
        headStyle={{ background: hexToRGBA(token.colorPrimary, 0.2) }}
        bodyStyle={{ padding: 0 }}
        title={
          <Space>
            <h2>{trackingTitle} Tracking</h2>{' '}
            <Select
              placeholder={`- Select ${trackingTitle} Trackers -`}
              value={null}
              style={{ width: 500 }}
              onChange={(selection) => {
                handleAddTracking('data', selection)
              }}
              showSearch
              options={dataPoints
                .filter((i) => filterChosenDataPoints(i))
                .map((dataPoint) => ({ label: dataPoint.label, value: JSON.stringify(dataPoint) }))}
            />
          </Space>
        }
      >
        <Table
          size='small'
          bordered
          dataSource={data}
          columns={CarePlanTemplatesNewRecordDataColumnTemplate(handleUpdateTracker, dataPoints, handleRemoveTracker)}
        />
      </Card>
    </Card>
  )
}

export default DataTrackerForm
